import { IEnvironment } from '@env/environment.model';

export const environment: IEnvironment = {
  production: true,
  legacy_api_server_url: 'https://developers.lightmetrics.co',
  intermediate_server_url: 'https://white-v2.lightmetrics.co',
  redirect_url: '',
  callbackURL: 'https://dashboard-targatelematics.lightmetrics.co/callback',
  scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
  cognitoConfigs: {
    'eu-central-1': {
      clientID: '7d9sklrqdbjmhtkahf1cinnks9',
      domain: 'https://eu-central-1poyutcswg.auth.eu-central-1.amazoncognito.com',
    },
  },
  env: 'prod',
};
